<template>
  <div class="layout">
    <!-- Barra lateral -->
    <div class="sidebar">
      <h3 class="sidebar-title">
        <font-awesome-icon :icon="['fas', 'users']" class="me-2" /> Gestión de Personal
      </h3>
      <ul class="nav nav-pills flex-column">
        <li class="nav-item">
          <button
            class="btn btn-link nav-link"
            :class="{ active: view === 'list' }"
            @click="view = 'list'"
          >
            <font-awesome-icon :icon="['fas', 'list']" class="me-2" /> Gestionar Personal
          </button>
        </li>
        <li class="nav-item">
          <button
            class="btn btn-link nav-link"
            :class="{ active: view === 'form' }"
            @click="createNewPersonal"
          >
            <font-awesome-icon :icon="['fas', 'user-plus']" class="me-2" /> Agregar Personal
          </button>
        </li>
      </ul>
    </div>

    <!-- Contenido principal -->
    <div class="content">
      <transition name="fade" mode="out-in">
        <template v-if="view === 'list'">
          <PersonalLista
            :personal="personal"
            @delete-personal="deletePersonal"
            @edit-personal="editPersonal"
          />
        </template>
        <template v-else-if="view === 'form'">
          <PersonalFormulario
            :form="form"
            :editing="editing"
            @save-personal="savePersonal"
            @cancel-edit="cancelEdit"
          />
        </template>
      </transition>
    </div>
  </div>
</template>



<style scoped>
/* General Layout */
.layout {
  display: flex;
  height: 100vh;
  background-color: #f7f9fc;
}

.sidebar {
  width: 280px;
  background-color: #ffffff;
  border-right: 1px solid #e5e5e5;
  padding: 20px;
}

.sidebar-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333333;
}

.nav-item {
  margin-bottom: 10px;
}

.nav-link {
  color: #555555;
  text-align: left;
  font-size: 1rem;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  background-color: var(--app-primary);
  color: #ffffff;
}

.content {
  flex-grow: 1;
  padding: 30px;
  background-color: #ffffff;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.05);
  overflow-y: auto;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>




<script>
import axios from '@/axios';
import PersonalLista from '../../components/Personal/PersonalLista.vue';
import PersonalFormulario from '../../components/Personal/PersonalFormulario.vue';

export default {
  name: 'PersonalGestion',
  components: {
    PersonalLista,
    PersonalFormulario,
  },
  data() {
    return {
      personal: [],
      view: 'list', // Vista actual ('list' o 'form')
      editing: false,
      clubActual: this.$store.getters.getClubActual,
      form: {
        id: null,
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        rol: '',
        estado: '',
        comentarios: '',
        legajo: '',
      },
    };
  },
  methods: {
    async fetchPersonal() {
      try {
        const response = await axios.get('/api/personal', {params:{club_id: this.clubActual.id}});
        this.personal = response.data;

       
      } catch (error) {
        console.error('Error al obtener el personal:', error);
      }
    },
    async deletePersonal(id) {
      try {
        //confirmacion 
        if (!confirm('¿Está seguro de eliminar este personal?')) {
          return;
        }
        await axios.delete(`/api/personal/${id}`, { params: { club_id: this.clubActual.id } });
        this.personal = this.personal.filter((persona) => persona.id !== id);
      } catch (error) {
        console.error('Error al eliminar personal:', error);
      }
    },
    editPersonal(persona) {
      this.form = { ...persona };
      this.editing = true;
      this.view = 'form';
    },
    createNewPersonal() {
      
      this.resetForm();
      this.view = 'form';

    },
    cancelEdit() {
      this.resetForm();
      this.view = 'list';
    },
    async savePersonal(form) {
      try {

        
        if (this.editing) {
          const resultado = await axios.put(`/api/personal/${form.id}`, { club_id: this.clubActual.id, form });
          
          if(resultado.status === 200){
            console.log("Se actualizó correctamente");
          } else {
            console.log("Error al actualizar");
          }
        } else {
          const resultado = await axios.post('/api/personal', { club_id: this.clubActual.id, form });
          
          if(resultado.status === 200){
            console.log("Se guardó correctamente");
          } else {
            console.log("Error al guardar");
          }
        }
        this.fetchPersonal();
        this.cancelEdit();
      } catch (error) {
        console.error('Error al guardar personal:', error);
      }
    },

    resetForm() {
      this.form = {
        id: null,
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        rol: '',
        estado: '',
        comentarios: '',

      };
      this.editing = false;
    },
  },
  mounted() {

    this.fetchPersonal();
  },
};
</script>

